import { h } from 'preact'; /** @jsx h */
import formatPrice from '../../utils/formatPrice';

import './CartItem.scss';

const CartItem = ({ item, updateQty, removeFromCart }) => {
    const categorySlug = item?.catName?.toLowerCase().replace(' ', '-');

    let shipmentTypeNumber = 0;

    if (item.shipmentType && item.shipmentType === 'Gavebevis på e-post') {
        shipmentTypeNumber = 1;
    } else if (item.shipmentType && item.shipmentType === 'Gavebevis i posten') {
        shipmentTypeNumber = 2;
    }

    return (
        <div
            className={`ws-product-item item-${item.id}-${item.qty}-${item.inputPrice}-${shipmentTypeNumber}`}
            key={item.id}
        >
            <div className="ws-item-img">
                <img src={item.imageUrl} alt={item.name} />
            </div>
            <div className="ws-item-info">
                {item.catId === 4 ? (
                    <div className="ws-item-title">
                        <h5>{item.name}</h5>
                    </div>
                ) : (
                    <a className="ws-item-title" href={`/nettbutikk/${categorySlug}/${item.slug}`}>
                        <h5>{item.name}</h5>
                    </a>
                )}
                <div className="ws-item-content">
                    <p>
                        {item.id === 150
                            ? 'Ingen leveringsmetode'
                            : item.catName === 'Produkter'
                            ? 'Produkt i posten'
                            : item.shipmentType}
                    </p>
                    <p>{item.taxDeduction ? 'Fradragsberettiget' : 'Ikke fradragsberettiget'}</p>
                </div>
            </div>
            <div className="ws-item-handle">
                <div className="ws-handle-top">
                    <p>
                        Pris: {formatPrice(item.donation || item.inputPrice || item.price)}
                        ,-
                    </p>
                </div>
                <div className="ws-handle-mid">
                    <div className="product-qty">
                        <button
                            className="product-qty-btn remove"
                            disabled={item.qty === 1}
                            onClick={() =>
                                updateQty(
                                    item.id,
                                    item.qty > 1 ? item.qty - 1 : 1,
                                    item.shipmentType,
                                    item.inputPrice
                                )
                            }
                        >
                            <span className="material-symbols-outlined">remove</span>
                        </button>
                        <input
                            type="number"
                            className="product-qty-count"
                            value={item?.qty}
                            min={1}
                            onChange={e => {
                                let value = e.target.value
                                    .replace(/[^0-9]/g, '1')
                                    .replace(/^0+/, '1');
                                if (value === '') {
                                    value = '1';
                                }
                                updateQty(
                                    item.id,
                                    parseInt(value),
                                    item.shipmentType,
                                    item.inputPrice
                                );
                            }}
                        />
                        <button
                            className="product-qty-btn add"
                            onClick={() =>
                                updateQty(item.id, item.qty + 1, item.shipmentType, item.inputPrice)
                            }
                        >
                            <span className="material-symbols-outlined">add</span>
                        </button>
                    </div>
                    <button
                        className="product-qty-btn delete"
                        title="Slett produkt"
                        onClick={() => removeFromCart(item)}
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>
                <div className="ws-handle-bottom">
                    <p>
                        Delsum:{' '}
                        {formatPrice((item.donation || item.inputPrice || item.price) * item.qty)}
                        ,-
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
